export const rules = {
    account: [
        {
            required: true,
            message: "请输入账号",
            trigger: "blur",
        },
        // {
        //     min: 6,
        //     max: 12,
        //     message: "账号长度在6-12位之间",
        //     trigger: "blur",
        // },
    ],
    phone: [
        {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
        },
        {
            pattern: /^1[345789]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
        },
    ],
    password: [
        {
            required: true,
            message: "请输入密码",
            trigger: "blur",
        },
        {
            min: 6,
            max: 12,
            message: "密码长度在6-12位之间",
            trigger: "blur",
        },
    ],
    code: [
        {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
        },
        {
            len: 4,
            message: "验证码长度为4位",
            trigger: "blur",
        },
    ]
};